import { render, staticRenderFns } from "./valorMonedasGemas.vue?vue&type=template&id=e2cb1cc2&scoped=true"
import script from "./valorMonedasGemas.vue?vue&type=script&lang=js"
export * from "./valorMonedasGemas.vue?vue&type=script&lang=js"
import style0 from "./valorMonedasGemas.vue?vue&type=style&index=0&id=e2cb1cc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cb1cc2",
  null
  
)

export default component.exports